export default __webpack_public_path__ + "static/media/rewards-lab.477319f8.png";